import { Button, Card, Form, Input } from "antd";
import { message } from "components/Messages/Messages";
import Title from "antd/lib/typography/Title";
import axios from "axios";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";

interface PasswordChangeValues {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const CompanyAccountSettings: React.FC = () => {
  const { currentUser } = useLoginContext();
  const [form] = Form.useForm<PasswordChangeValues>();
  const onPasswordChangeFormSubmit = (values: PasswordChangeValues) => {
    if (!currentUser || !isCompanyUser(currentUser)) {
      return message("error", "Kun bedriftsbrukere kan endre passord her.");
    }
    axios
      .post(`/companies/${currentUser.id}/change-password/`, {
        current_password: values.currentPassword,
        new_password: values.newPassword,
      })
      .then(() => {
        message("success", "Passordet ditt har blitt oppdatert.");
        form.resetFields();
      })
      .catch(error => {
        if (error.response && error.response.data) {
          const errorMsg = Object.values(error.response.data).join("\n") || "Noe gikk galt. Vennligst prøv igjen.";
          message("error", errorMsg);
        } else {
          message("error", "Noe gikk galt. Vennligst prøv igjen.");
        }
      });
  };

  return (
    <>
      <Title level={2}>Bytt passord</Title>
      <Card>
        <Form<PasswordChangeValues>
          form={form}
          onFinish={onPasswordChangeFormSubmit}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item
            name="currentPassword"
            label="Nåværende passord"
            rules={[{ required: true, message: "Vennligst skriv inn nåværende passord" }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="Nytt passord"
            rules={[
              { required: true, message: "Vennligst skriv inn nytt passord" },
              { min: 8, message: "Passordet må være minst 8 tegn" },
            ]}
            hasFeedback
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Bekreft nytt passord"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              { required: true, message: "Vennligst bekreft nytt passord" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("De to passordene er ikke like"));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Oppdater passord
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
};

export default CompanyAccountSettings;
